import styled from 'styled-components';
import Title from '../common/html/Title';
import SubTitle from '../common/html/SubTitle';
import Image from '../common/html/Image';

const Content = styled.div`
    text-align: center;
    left: 0;
    right: 0;
    margin: 0 auto;
    transition: transform ease 0.5s;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
`;

const BgImage = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    opacity: 0.65;
    transform: scale3d(1, 1, 1);
    transition: opacity ease 0.5s, transform ease 0.5s;
    background-image: url(${p => p.imageUrl || ''});
`;

const Section = styled.a`
    position: relative;
    display: block;
    height: 90vh;
    min-height: 800px;
    background-color: #000;
    cursor: pointer;

    ${p => p.theme.breakpoints.down('sm')} {
        height: 70vh;
        min-height: 500px;
    }

    ${p => p.theme.breakpoints.between('sm', 'md')} {
        height: 50vh;
        min-height: 700px;
    }

    &:hover {
        ${p => p.theme.breakpoints.up('md')} {
            ${Content} {
                transform: translateY(-52%);
            }
            ${BgImage} {
                opacity: 0.35;
            }
        }
    }
`;

const H1 = styled(Title)`
    text-align: center;
    margin: 2rem auto 0;
    max-width: 30rem;
    text-transform: uppercase;
    ${p => p.theme.breakpoints.down('sm')} {
        margin: 1rem 0;
        font-size: 3.5em;
        max-width: initial;
        width: 100%;
    }
    ${p => p.theme.breakpoints.between('sm', 'md')} {
        font-size: 2.8em;
    }
`;

const H2 = styled(SubTitle)`
    text-align: center;
    margin: 1em auto 0;
`;

const Icon = styled(Image)`
    width: auto;
    height: 16em;
    margin: 4em auto;
    ${p => p.theme.breakpoints.down('lg')} {
        height: 10em;
    }
`;

export {Content, BgImage, Section, H1, H2, Icon};
